module.exports = __webpack_public_path__ + "static/media/emma_vp_orphanage.5a038bb3.jpg";